// src/pages/DirectPage/MessagesList.jsx
import React, { useEffect, useRef } from 'react';
import { directPageStyles } from './styles';
import MessageBubble from './MessageBubble';

// Empty Chat Icon SVG
const EmptyChatIcon = () => (
  <svg width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
    <line x1="9" y1="10" x2="15" y2="10" />
    <line x1="9" y1="14" x2="13" y2="14" />
  </svg>
);

const MessagesList = ({ directs, currentUserId, seller, currentUser }) => {
  const messagesContainerRef = useRef(null);
  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    if (messagesContainerRef.current) {
      messagesContainerRef.current.scrollTop = messagesContainerRef.current.scrollHeight;
    }
  };

  useEffect(() => {
    scrollToBottom();
  }, [directs]);

  if (directs.length === 0) {
    return (
      <div style={directPageStyles.messagesContainer} ref={messagesContainerRef}>
        <div style={directPageStyles.emptyState}>
          <div style={directPageStyles.emptyIcon}>
            <EmptyChatIcon />
          </div>
          <h3 style={directPageStyles.emptyTitle}>No Messages Yet</h3>
          <p style={directPageStyles.emptyMessage}>
            Start the conversation! Say hello 
          </p>
        </div>
      </div>
    );
  }

  return (
    <div style={directPageStyles.messagesContainer} ref={messagesContainerRef}>
      {directs.map((message, index) => {
        const previousMessage = directs[index - 1];
        const isCurrentUser = message.senderId === currentUserId;
        
        // Show avatar only if it's the last message in a group from the same sender
        const nextMessage = directs[index + 1];
        const isNextFromDifferentSender = !nextMessage || nextMessage.senderId !== message.senderId;
        const showAvatar = isNextFromDifferentSender;

        // Check if we need extra spacing (different sender than previous)
        const isPreviousFromDifferentSender = !previousMessage || previousMessage.senderId !== message.senderId;

        return (
          <MessageBubble
            key={message.id}
            message={message}
            isCurrentUser={isCurrentUser}
            showAvatar={showAvatar}
            seller={seller}
            currentUser={currentUser}
            isFirstInGroup={isPreviousFromDifferentSender}
          />
        );
      })}
      <div ref={messagesEndRef} />
    </div>
  );
};

export default MessagesList;